@if (!user) {
  <fa-icon icon="spinner" animation="spin"></fa-icon>
}

@if (user) {
  <form [formGroup]="employeeForm" novalidate class="rounded-bottom">
    <div class="container">
      <div class="form-group mb-0">
        <div class="row pt-1 pb-1 rounded border">
          <div class="col-xs-6 col-md-3">
            <input type="text" [class]="employeeForm.controls['firstname'].disabled ? 'form-control-plaintext' : 'form-control'" formControlName="firstname" placeholder="{{ 'Template.EmployeeComponent.placeholder_firstName' | translate }}" />
          </div>
          <div class="col-xs-6 col-md-3">
            <input type="text" [class]="employeeForm.controls['lastname'].disabled ? 'form-control-plaintext' : 'form-control'" formControlName="lastname" placeholder="{{ 'Template.EmployeeComponent.placeholder_lastName' | translate }}" />
          </div>
          <div class="col-xs-6 col-md-3">
            @if (!user.externalAuthId) {
              <button class="btn" (click)="showForm(employeeForm, user, employeeForm.controls['editing'])" type="button" placement="top" ngbTooltip="{{ 'Template.EmployeeComponent.tooltip_rename' | translate }}" [class]="employeeForm.controls['editing'].value ? 'btn-outline-danger' : 'btn-secondary'">
                @if (!employeeForm.controls['editing'].value) {
                  <fa-icon icon="pencil-alt"> </fa-icon>
                }
                @if (employeeForm.controls['editing'].value) {
                  <fa-icon icon="circle-xmark"> </fa-icon>
                }
              </button>
            }
          </div>
          <div class="col-xs-6 col-md-3 text-end">
            @if (userParty?.relationships?.length! > 1) {
              <button type="button" class="btn btn-link btn-sm" triggers="hover" popoverTitle="{{ 'Template.EmployeeComponent.text_moreUserAccesses' | translate }}" [ngbPopover]="popContent">
                {{ "Template.EmployeeComponent.btn_moreUserAccesses" | translate }}
                <fa-icon icon="user-friends"></fa-icon>
              </button>
            }
            @if (!isAdmin && userParty?.relationships?.length! > 1) {
              <button class="btn btn-danger" (click)="unlinkUser(user)" placement="top" ngbTooltip="{{ 'Template.EmployeeComponent.tooltip_unlinkUser' | translate }}">
                <fa-icon icon="unlink"></fa-icon>
              </button>
            }
            @if (!(userParty?.relationships?.length! > 1)) {
              <button class="btn btn-danger" (click)="deleteUser(user)" placement="top" ngbTooltip="{{ 'Template.EmployeeComponent.tooltip_removeUser' | translate }}" [disabled]="!userParty">
                <fa-icon icon="user-xmark"></fa-icon>
              </button>
            }
            <ng-template #popContent>
              {{ "Template.EmployeeComponent.text_userHasOtherLinks" | translate }}:<br />
              @for (partyRel of userParty?.enrichedRelationships! | otherPartyRels : party?.partyId!; track partyRel) {
                <span class="d-block">
                  {{ (partyRel.toParty?.attributes)!["NAME"] }}
                </span>
              }
            </ng-template>
          </div>
          <div class="col-12">
            @if (employeeForm.controls['editing'].value) {
              <button type="button" [attr.disabled]="user.loading ? '' : null" class="btn btn-primary mt-2" (click)="updateUserName(user, employeeForm.controls['firstname'].value, employeeForm.controls['lastname'].value, employeeForm)">
                {{ "Template.EmployeeComponent.btn_save" | translate }}
                <fa-icon icon="check"></fa-icon>
                @if (user.loading) {
                  <fa-icon icon="spinner" animation="spin"></fa-icon>
                }
              </button>
            }
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-6 col-md-4">
          <div class="ps-3">
            <div>
              <strong class="text-primary">{{ user.email }}</strong>
              @if (user.externalAuthId) {
                <img class="mx-1" src="/assets/images/sso/sso-badge-sm.png" ngbTooltip="{{ 'Template.EmployeeComponent.tooltip_ssoLinked' | translate }}" />
              }
            </div>
            <strong>{{ "Template.EmployeeComponent.text_status" | translate }}:</strong>
            @if ((party && !party.enabled) || !user.enabled) {
              <span>
                {{ "Template.EmployeeComponent.text_disabled" | translate }}
                <fa-icon icon="info-circle" placement="bottom" ngbTooltip="{{ 'Template.EmployeeComponent.tooltip_userCustomerDisabled' | translate }}"> </fa-icon>
              </span>
            }
            @if ((!party || party.enabled) && user.enabled && !user.lastLoginDate && user.requirePasswordChange) {
              <span>
                {{ "Template.EmployeeComponent.text_invited" | translate }}
                <br />
                {{ "Template.EmployeeComponent.text_dateTime" | translate : { dateTime: user.createdDate | date : "dd.MM.yyyy, HH:mm" } }}
              </span>
            }
            @if ((!party || party.enabled) && user.enabled && user.lastLoginDate && user.requirePasswordChange) {
              <span>
                {{ "Template.EmployeeComponent.text_passwordReset" | translate }}
                <br />
                {{ "Template.EmployeeComponent.text_dateTime" | translate : { dateTime: user.passwordResetDate | date : "dd.MM.yyyy, HH:mm" } }}
              </span>
            }
            @if ((!party || party.enabled) && user.enabled && user.lastLoginDate && !user.requirePasswordChange) {
              <span>
                {{ "Template.EmployeeComponent.text_enabled" | translate }}
              </span>
            }
            @if ((!party || party.enabled) && user.enabled && !user.lastLoginDate && !user.requirePasswordChange) {
              <span> {{ "Template.EmployeeComponent.text_migrated" | translate }} </span>
            }
          </div>
        </div>
        <div class="col-6 col-md-4">
          <strong>{{ "Template.EmployeesComponent.text_lastLogin" | translate }}: </strong>
          @if (user.lastLoginDate) {
            <span>
              {{ "Template.EmployeesComponent.text_dateTime2" | translate : { dateTime: user.lastLoginDate | date : "dd.MM.yyyy, HH:mm" } }}
            </span>
          }
          @if (!user.lastLoginDate) {
            <span>---</span>
          }
          <br />
          <strong>{{ "Template.EmployeesComponent.text_lastFtpLogin" | translate }}: </strong>
          @if (user.lastFtpLoginDate) {
            <span>
              {{ "Template.EmployeesComponent.text_dateTime2" | translate : { dateTime: user.lastFtpLoginDate | date : "dd.MM.yyyy, HH:mm" } }}
            </span>
          }
          @if (!user.lastFtpLoginDate) {
            <span>---</span>
          }
        </div>
        <div class="col-6 col-md-4">
          <div class="text-end">
            @if (!user.externalAuthId) {
              <button class="btn btn-secondary mx-1 btn-custom" (click)="resetPassword(user)" placement="top" ngbTooltip="{{ 'Template.EmployeesComponent.tooltip_resetPassword' | translate }}" [disabled]="(party && !party.enabled) || !user.enabled">
                <fa-icon icon="undo"></fa-icon>
              </button>
            }
            @if (user.externalAuthId) {
              <button class="btn btn-secondary mx-1 btn-custom" (click)="showSsoPanel(user)" placement="top" ngbTooltip="{{ 'Template.EmployeeComponent.tooltip_openSsoPanel' | translate }}" [disabled]="(party && !party.enabled) || !user.enabled">
                <fa-icon icon="id-card"></fa-icon>
              </button>
            }
            @if (!user.externalAuthId) {
              <button class="btn btn-warning mx-1 btn-custom" (click)="openModal(changeEmailModal)" placement="top" ngbTooltip="{{ 'Template.EmployeeComponent.tooltip_changeEmail' | translate }}" [disabled]="(party && !party.enabled) || !user.enabled">
                <fa-icon icon="at"></fa-icon>
              </button>
            }
            @if (!user.enabled) {
              <button class="btn btn-success mx-1 btn-custom" (click)="toggleUser(user, true)" placement="top" ngbTooltip="{{ 'Template.EmployeesComponent.tooltip_enableUserAccess' | translate }}" [disabled]="party && !party.enabled">
                <fa-icon icon="unlock"></fa-icon>
              </button>
            }
            @if (user.enabled) {
              <button class="btn btn-warning mx-1 btn-custom" (click)="toggleUser(user, false)" placement="top" ngbTooltip="{{ 'Template.EmployeesComponent.tooltip_disableUserAccess' | translate }}" [disabled]="party && !party.enabled">
                <fa-icon icon="lock"></fa-icon>
              </button>
            }
            @if (!isAdmin && (!userParty?.attributes?.['DISABLE_EMAILS'] || userParty?.attributes?.['DISABLE_EMAILS'] == 'N')) {
              <button class="btn btn-success mx-1 btn-custom" (click)="setUserAttribute(user, 'DISABLE_EMAILS', 'Y')" ngbTooltip="{{ 'Template.EmployeesComponent.tooltip_excludeFromEmails' | translate }}" placement="top" [disabled]="party && !party.enabled">
                <fa-icon icon="envelope"></fa-icon>
              </button>
            }
            @if (!isAdmin && (userParty?.attributes?.['DISABLE_EMAILS']! == 'Y')) {
              <button class="btn btn-danger mx-1 btn-custom" (click)="setUserAttribute(user, 'DISABLE_EMAILS', 'N')" ngbTooltip="{{ 'Template.EmployeesComponent.tooltip_enableEmails' | translate }}" placement="top" [disabled]="party && !party.enabled">
                <fa-icon icon="envelope"></fa-icon>
              </button>
            }
            @if (user.externalAuthId) {
              <button class="btn btn-outline-danger mx-1 btn-custom" (click)="unlinkSsoAccount()" ngbTooltip="{{ 'Template.EmployeeComponent.tooltip_unlinkSso' | translate }}" placement="top" [disabled]="unlinkingSso">
                <fa-icon icon="unlink"></fa-icon>
              </button>
            }
          </div>
        </div>
      </div>
    </div>
  </form>
}

<ng-template #changeEmailModal let-modal>
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">{{ "Template.EmployeeComponent.subHeader_changeEmail" | translate }}</h4>
      <button type="button" class="btn-close" aria-label="{{ 'Common.btn_close' | translate }}" (click)="modal.dismiss()"></button>
    </div>

    @if (user && username) {
      <div class="modal-body">
        @if (user.externalAuthId) {
          <p>{{ "Template.EmployeeComponent.text_userMustChangeEmail" | translate }}</p>
        }
        @if (!user.externalAuthId) {
          <app-email-form-legacy class="col-10" [email]="user.email" [mode]="FORM_COMP_MODES.EDIT" [username]="username" (exitFormEvent)="exitEmailForm($event)"></app-email-form-legacy>
        }
      </div>
    }
  </div>
</ng-template>
